import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=75eb0b4f&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75eb0b4f')) {
      api.createRecord('75eb0b4f', component.options)
    } else {
      api.reload('75eb0b4f', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=75eb0b4f&", function () {
      api.rerender('75eb0b4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NT4PYv3D7b24/JS/cancellationPolicy.vue"
export default component.exports